import { render, staticRenderFns } from "./RankingBoard.vue?vue&type=template&id=a61201e6"
import script from "./RankingBoard.vue?vue&type=script&lang=js"
export * from "./RankingBoard.vue?vue&type=script&lang=js"
import style0 from "./RankingBoard.vue?vue&type=style&index=0&id=a61201e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports